// extracted by mini-css-extract-plugin
export default {"errorText":"map-component_errorText__Hv64n"};